import PropTypes from 'prop-types';

export const PickPropType = PropTypes.shape({
  pick_name: PropTypes.string.isRequired,
  opponent_name: PropTypes.string.isRequired,
  budget_amount: PropTypes.number.isRequired,
  american_odds: PropTypes.string.isRequired,
  decimal_odds: PropTypes.number.isRequired,
  supporting_strategies: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['moneyline', 'parlay']).isRequired,
});

export const PlaybookPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  strategies: PropTypes.number.isRequired,
  picks: PropTypes.arrayOf(PickPropType).isRequired,
  last_updated: PropTypes.string.isRequired,
});

export const PLAYBOOK_TYPES = {
  BASELINE: 'baseline',
  FLURRY: 'flurry',
  STANDARD: 'standard',
  FLEX: 'flex',
  GROWTH: 'growth',
  DRAKE: 'drake',
  SHARKS: 'sharks',
  VALUE: 'value',
  EQUAL: 'equal',
}; 